if (!customElements.get('addon-option')) {
  customElements.define(
    'addon-option',
    class AddonOption extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.groupInput = this.querySelector('input[name="properties[_flex_addon_group]"]');
        this.status = this.querySelector('.flex-addon__status');
        this.newGroup();

        // チェックがあるときだけ本商品の行にグループを付ける（オプションなしの本商品は従来どおり1行にまとまる）
        this.addEventListener('change', () => {
          this.groupInput.disabled = this.checkedIds().length === 0;
        });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
        }

        // カートの種類が「ページ」だと、本商品の追加直後に /cart へ移動してオプションを追加する前にページが変わる。
        // その場合は product-form より先に送信を受け取り、本商品とオプションを1回のリクエストでまとめて追加する
        this.onSubmitCapture = this.onSubmitCapture.bind(this);
        document.addEventListener('submit', this.onSubmitCapture, true);
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
        document.removeEventListener('submit', this.onSubmitCapture, true);
      }

      onSubmitCapture(event) {
        if (event.target !== this.form || this.checkedIds().length === 0) return;
        if (document.querySelector('cart-drawer, cart-notification')) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const formData = new FormData(this.form);
        const properties = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value !== '') properties[match[1]] = value;
        }
        const quantity = parseInt(formData.get('quantity')) || 1;
        const main = { id: Number(formData.get('id')), quantity, properties };
        const items = [main, ...this.addonItems(properties._flex_addon_group, quantity)];

        const button = this.form.querySelector('[type="submit"]');
        button?.setAttribute('aria-disabled', true);
        button?.classList.add('loading');

        fetch(`${routes.cart_add_url}.js`, { ...fetchConfig('json'), body: JSON.stringify({ items }) })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showStatus(response.description || response.message);
              button?.removeAttribute('aria-disabled');
              button?.classList.remove('loading');
              return;
            }
            window.location = routes.cart_url;
          })
          .catch(() => {
            this.showStatus(this.dataset.errorMessage);
            button?.removeAttribute('aria-disabled');
            button?.classList.remove('loading');
          });
      }

      addonItems(group, quantity) {
        const variantTitle = this.variantTitle();
        const target = variantTitle ? `${this.dataset.productTitle} / ${variantTitle}` : this.dataset.productTitle;
        return this.checkedIds().map((id) => ({
          id: Number(id),
          quantity,
          properties: { [this.dataset.targetLabel]: target, _flex_addon_parent: group },
        }));
      }

      newGroup() {
        this.groupInput.value = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
      }

      checkedIds() {
        return [...this.querySelectorAll('.flex-addon__checkbox:checked')].map((checkbox) => checkbox.value);
      }

      onCartUpdate(event) {
        if (event?.source !== 'product-form' || !this.form) return;
        // 同じページのクイック追加（おすすめ商品など）では反応しない
        const variantInput = this.form.querySelector('[name="id"]');
        if (!variantInput || String(event.productVariantId) !== variantInput.value) return;

        const ids = this.checkedIds();
        if (ids.length === 0) return;

        const group = this.groupInput.value;
        const quantity = parseInt(new FormData(this.form).get('quantity')) || 1;
        const items = this.addonItems(group, quantity);

        // 次の追加は別の行として扱う（同じ商品を2回入れたとき、どちらのラッピングかを区別するため）
        this.newGroup();

        fetch(`${routes.cart_add_url}.js`, {
          ...fetchConfig('json'),
          body: JSON.stringify({ items }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showStatus(response.description || response.message);
              return;
            }
            this.showStatus('');
            this.querySelectorAll('.flex-addon__checkbox:checked').forEach((checkbox) => (checkbox.checked = false));
            this.groupInput.disabled = true;
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'flex-addon-option' });
          })
          .catch(() => this.showStatus(this.dataset.errorMessage));
      }

      variantTitle() {
        const json = this.closest('product-info')?.querySelector('variant-selects [data-selected-variant]');
        try {
          const variant = json ? JSON.parse(json.textContent) : null;
          if (variant && variant.title && variant.title !== 'Default Title') return variant.title;
        } catch (e) {}
        return '';
      }

      showStatus(message) {
        if (!this.status) return;
        this.status.textContent = message || '';
        this.status.hidden = !message;
      }
    }
  );
}
